<template>
  <div class="news-full">
    <router-link :to="{name: 'news'}">Tutte le news</router-link>
    <div class="date">{{ datestamp(news.data) }}</div>
    <div class="title">{{ news.title }}</div>
    <div class="image"><img :src="absoluteURL(news.featured_image.url)" v-if="news.featured_image.url"/></div>
    <div class="body" v-html="news.body.value"></div>
    <div class="documents" v-for="document in news.documents" v-if="news.documents">
      <a :href="absoluteURL(document.url)" target="_blank">Download</a>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import Waterwheel from "waterwheel"
  import jsonapiParse from "jsonapi-parse";

  const waterwheel = new Waterwheel(
      {
        base: process.env.VUE_APP_HOST_URL,
        jsonapiPrefix: 'api',
        timeout: 3000,
        accessCheck: false
      }
  );


  export default {
    name: 'NewsFull',
    props: ['slug'],
    data() {
      return {
        title: '',
        news: [],
        loading: true
      }
    },
    metaInfo() {
      return {
        title: this.loading ? 'Loading...' : this.title,
        titleTemplate: '%s - Gabiano Holding',
      }
    },
    created() {
      const query = {
        filter: {
          status: 1,
          '[alias][condition][path]' : 'field_path',
          '[alias][condition][value]' : '/news/' + this.slug,
        },
        include: 'featured_image, documents',
      }

      waterwheel.jsonapi.get('node/news/', query).then(news => {
        this.news = jsonapiParse.parse(news).data[0];
        this.title = this.news.title;
      }).catch(error => console.log('error on getPage: ', error))
          .finally(() => {
            this.loading = false;
          });

    },
    methods: {
      datestamp: function (date) {
        return moment(date).locale('it').format('LL');
      },
      absoluteURL(relativeURL) {
        return process.env.VUE_APP_HOST_URL + relativeURL;
      }
    }
  }
</script>
